export default function DocumentIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.09368 0.266264C6.26038 0.0957818 6.48647 0 6.72222 0H13.8333C15.3061 0 16.5 1.22105 16.5 2.72727V17.2727C16.5 18.779 15.3061 20 13.8333 20H3.16667C1.69391 20 0.5 18.779 0.5 17.2727V6.36364C0.5 6.12253 0.593653 5.8913 0.760347 5.72081L6.09368 0.266264ZM13.8333 1.81818H7.61111V6.36364C7.61111 6.86571 7.21316 7.27273 6.72222 7.27273H2.27778V17.2727C2.27778 17.7748 2.67575 18.1818 3.16667 18.1818H13.8333C14.3243 18.1818 14.7222 17.7748 14.7222 17.2727V2.72727C14.7222 2.2252 14.3243 1.81818 13.8333 1.81818ZM3.53485 5.45455H5.83333V3.10383L3.53485 5.45455ZM4.05556 10.9091C4.05556 10.407 4.45353 10 4.94444 10H12.0556C12.5465 10 12.9444 10.407 12.9444 10.9091C12.9444 11.4112 12.5465 11.8182 12.0556 11.8182H4.94444C4.45353 11.8182 4.05556 11.4112 4.05556 10.9091ZM4.05556 14.5455C4.05556 14.0434 4.45353 13.6364 4.94444 13.6364H12.0556C12.5465 13.6364 12.9444 14.0434 12.9444 14.5455C12.9444 15.0475 12.5465 15.4545 12.0556 15.4545H4.94444C4.45353 15.4545 4.05556 15.0475 4.05556 14.5455Z"
        fill="black"
      />
    </svg>
  );
}
